import '@datadog/browser-rum/bundle/datadog-rum';

// Datadog docs: https://docs.datadoghq.com/real_user_monitoring/browser/
export function initializeDatadog(env) {
  window.DD_RUM.init({
    applicationId: '5afdc005-cfbd-4a5c-bcba-bb17158500f7',
    clientToken: 'pub89e0ba03ca28dcaf02ff28eb08087b6e',
    site: 'us5.datadoghq.com',
    service: 'sittercity-web',
    sampleRate: 100,
    premiumSampleRate: 0,
    trackInteractions: true,
    trackResources: true,
    allowedTracingUrls: [/^https:\/\/([a-zA-Z0-9-]+\.)*sittercity\.com(\/|$)/],
    allowedTracingOrigins: [/^https:\/\/([a-zA-Z0-9-]+\.)*sittercity\.com(\/|$)/],
    env,
  });
}

export default {
  initializeDatadog,
};
